import { z } from 'zod';

export const SEARCH_GROUPS = [
  'projects',
  'clients',
  'tasks',
  'files',
  'boards',
  'storyboards',
  'notes',
  'comments',
  'invoices',
] as const;
export type SearchGroup = (typeof SEARCH_GROUPS)[number];

export const searchQuery = z.object({
  q: z.string().trim().min(2).max(120),
  only: z.enum(SEARCH_GROUPS).optional(),
});

export const searchHit = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  /** Caminho no app para abrir o resultado. */
  href: z.string(),
});
export type SearchHit = z.infer<typeof searchHit>;

export const searchDto = z.object({
  q: z.string(),
  groups: z.array(z.object({ group: z.enum(SEARCH_GROUPS), hits: z.array(searchHit) })),
});
export type SearchDto = z.infer<typeof searchDto>;
